<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="Camada_2" viewBox="0 0 25.17 29.05">
    <g id="Camada_1-2" data-name="Camada_1">
      <g>
        <path
          d="M0,14.53c0,3.26,0,6.53,0,9.79,0,2.89,1.83,4.72,4.7,4.73,2.65,0,5.3,0,7.95,0,.25,0,.5,0,.74-.06.69-.16,1.14-.74,1.12-1.43-.01-.66-.44-1.21-1.11-1.37-.26-.06-.54-.07-.81-.07-2.65,0-5.3,0-7.95,0-1.23,0-1.72-.5-1.72-1.74,0-6.57,0-13.14,0-19.71,0-1.24.49-1.73,1.73-1.73,2.63,0,5.26,0,7.88,0,.23,0,.46,0,.68-.02.77-.11,1.29-.69,1.3-1.42,0-.76-.53-1.38-1.33-1.46-.56-.05-1.13-.02-1.7-.02-2.27,0-4.53,0-6.8,0C1.85.01,0,1.84,0,4.68c0,3.29,0,6.57,0,9.86Z" />
        <path
          d="M21.71,13.55c-.16,0-.32,0-.48,0-3.4,0-6.8,0-10.2,0-.17,0-.33,0-.5.02-.51.08-.85.47-.85.96,0,.49.34.88.86.96.16.02.33.02.5.02,3.4,0,6.8,0,10.2,0h.47s.06.09.08.14c-.49.46-.98.92-1.47,1.38-.24.23-.48.46-.7.71-.37.41-.36.98,0,1.35.36.37.93.38,1.35.02.06-.05.11-.1.16-.16,1.2-1.2,2.39-2.39,3.59-3.59.59-.59.58-1.08,0-1.67-1.23-1.23-2.45-2.46-3.69-3.68-.36-.35-.82-.41-1.2-.2-.38.21-.59.66-.44,1.08.07.22.23.42.39.59.64.66,1.3,1.3,1.95,1.95-.01.04-.02.08-.03.11Z" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LogoutIcon'
}
</script>
